import React from 'react';
import Hero from './Hero';
import NavbarStandard from './NavbarStandard';
import Processes from './Processes';
import Services from './Services';
import LandingBlog from './LandingBlog';
import LandingFaq from './LandingFaq';
import Cta from './Cta';
import FooterStandard from './FooterStandard';

const Landing = () => {
  return (
    <>
      <NavbarStandard />
      <Hero />
      <Services />
      <Processes />
      <LandingFaq />
      <LandingBlog />
      <Cta />
      <FooterStandard />
    </>
  );
};

export default Landing;
